import { useMemo } from 'react';

import { getRichtextValue } from '../shared/logic/get-richtext-value';
import {
  BASE_FILL_IN_BLANKS_TEXT_BLOCK_SETTINGS,
  FillInBlanksText,
} from './fill-in-blanks.constants';
import { FillInBlanksTextBlock as FillInBlanksTextBlockStyled } from './fill-in-blanks-shared.style';
import { getExtensions } from 'approot/shared/richtext/richtext.utils';

const FillInBlanksTextBlock = ({
  textBlock,
}: {
  textBlock: FillInBlanksText;
}) => {
  const richtext = useMemo(() => {
    return getRichtextValue(
      textBlock.text,
      getExtensions(BASE_FILL_IN_BLANKS_TEXT_BLOCK_SETTINGS)
    );
  }, [textBlock.text]);

  return richtext ? (
    <FillInBlanksTextBlockStyled
      key={textBlock.itemId}
      dangerouslySetInnerHTML={{ __html: richtext }}
    />
  ) : null;
};

export default FillInBlanksTextBlock;
